function loadBehavioralAdvertisingTags() {
  //alert('Marketing tags loaded');
}

function loadAnalyticsTags() {
  // Segment-Unilever
  !function(){ var analytics=window.analytics=window.analytics||[];if(!analytics.initialize)if(analytics.invoked)window.console&&console.error&&console.error("Segment snippet included twice.");else{analytics.invoked=!0;analytics.methods=["trackSubmit","trackClick","trackLink","trackForm","pageview","identify","reset","group","track","ready","alias","debug","page","once","off","on","addSourceMiddleware","addIntegrationMiddleware","setAnonymousId","addDestinationMiddleware"];analytics.factory=function(e){return function(){var t=Array.prototype.slice.call(arguments);t.unshift(e);analytics.push(t);return analytics}};for(var e=0;e<analytics.methods.length;e++){var key=analytics.methods[e];analytics[key]=analytics.factory(key)}analytics.load=function(key,e){var t=document.createElement("script");t.type="text/javascript";t.async=!0;t.src="https://cdn.segment.com/analytics.js/v1/" + key + "/analytics.min.js";var n=document.getElementsByTagName("script")[0];n.parentNode.insertBefore(t,n);analytics._loadOptions=e};analytics._writeKey="kLD1mQqHIOq6zeDSogoUDxfTLWCl4V5m";;analytics.SNIPPET_VERSION="4.15.3";
  analytics.load("kLD1mQqHIOq6zeDSogoUDxfTLWCl4V5m");
  analytics.page();
  }}();

  var segmentCustomScript = document.createElement('script');
  segmentCustomScript.id = 'segment-custom-script';
  segmentCustomScript.type = 'text/javascript';
  segmentCustomScript.src = '../Segment-custom.js';


  // Convert

  // Create script tag
  // var convertScript = document.createElement('script');
  // convertScript.id = 'convert-script';
  // convertScript.type = 'text/javascript';

  // Set inline script to contents of third party script
  // var inlineScript = document.createTextNode(`alert('Essential services tags loaded');`);

  // convertScript.appendChild(inlineScript);
  // document.head.appendChild(convertScript);

  //  'var _conv_page_type = "{% if template == \'index\' %}homepage{% else template == "collections" %}collection{% else template == "article" %}article{% else template == "product" %}product{% else template == "cart" %}cart{% else %}other{% endif %}";
  //  var _conv_category_id = "";
  //  var _conv_category_name = "{{ collection.title }}";
  //  var _conv_product_sku = "";
  //  var _conv_product_name = "{{ product.title }}";
  //  var _conv_product_price = "{{ product.compare_at_price_min | money }}";
  //  var _conv_customer_id = "";
  //  var _conv_custom_v1 = "{{ tag }}";
  //  var _conv_custom_v2 = "{{ order.shipping_address.province }}";
  //  var _conv_custom_v3 = "{{ cart.item_count }}";
  //  var _conv_custom_v4 = "{{ cart.total_price | money_without_currency }}";


  var convertScript2 = document.createElement('script');
  convertScript2.id = 'marketing-script';
  convertScript2.type = 'text/javascript';
  // Set source of script tag
  convertScript2.src = '//cdn-3.convertexperiments.com/js/'+CONVERT_PROJECT_ID+'.js';
  //alert('Analytics tags loaded');
  $(window).trigger('analyticsReady');
}

function loadEssentialServicesTags() {
  // Check if tag has already been loaded
  if (document.getElementById('essential-script')) return;

  // // Create script tag
  // var essentialScript = document.createElement('script');
  // essentialScript.id = 'essential-script';
  // essentialScript.type = 'text/javascript';

  // // Set inline script to contents of third party script
  // var inlineScript = document.createTextNode(`alert('Essential services tags loaded');`);

  // // Append inline script to script tag
  // essentialScript.appendChild(inlineScript);

  // // Append script tag to head
  // document.head.appendChild(essentialScript);
  //alert('Essential tags loaded');
}

function loadTagsOnPage(purposes, purposesKeys) {
  purposesKeys.forEach(key => {
      switch(key) {
          case 'essential_services':
              // Load essential services tags if visitor has given consent
              if (purposes[key] === true) {
                  loadEssentialServicesTags();
              }
              break;
          case 'analytics':
              // Load analytics tags if visitor has given consent
              if (purposes[key] === true) {
                  loadAnalyticsTags();
              }
              break;
          case 'behavioral_advertising':
              // Load marketing tags if visitor has given consent
              if (purposes[key] === true) {
                  loadBehavioralAdvertisingTags();
              } else {
                Shopify.analytics.publish("ketchPermitChanged", {'test': 'test'});
              }
              break;
      }
  });
}

// Add event listener to be called anytime permit values are loaded 
//  or when an end-user updates their consent.
window.ketch('on', 'consent', function(c) {
  var puporsesKeys = Object.keys(c.purposes);
  loadTagsOnPage(c.purposes, puporsesKeys);  
});